import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../selectors/analytics';
import {
  selectCanPayByCard,
  selectIsAgencyBalanceVisible,
  selectIsMasterMoneySource,
  selectIsSubagent,
  selectSubagentSpendLimit,
} from '../../selectors/user';
import { selectTotalBalance, selectAuctionPointsBalance, selectCanFillBalance } from '../../selectors/balance';
import { useAppContext } from '../../../AppModulesWrapper';
import { Device } from '../common/Device';
import { BalanceDesktop, BalanceMobile } from './components';
import { trackLegalDepositLinkClick, trackNaturalDepositLinkClick } from './tracking';
import { getBalanceString, getIsShowAgencyBalance } from './utils';
import { setRecommendedPackageCheckoutFillBalance } from '../../actions/recommendedPackages';
import { topUpBalanceThunk } from '../../thunks/payment/topUpBalance';

export const BalanceContainer = () => {
  const { isMicrofrontend } = useAppContext();

  const dispatch = useDispatch();

  const balance = useSelector(selectTotalBalance);
  const auctionPoints = useSelector(selectAuctionPointsBalance);
  const canFillBalance = useSelector(selectCanFillBalance);
  const isMasterMoneySource = useSelector(selectIsMasterMoneySource);
  const subagentSpendLimit = useSelector(selectSubagentSpendLimit);
  const isSubagent = useSelector(selectIsSubagent);
  const isAgencyBalanceVisible = useSelector(selectIsAgencyBalanceVisible);
  const canPayByCard = useSelector(selectCanPayByCard);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);

  const isSubagentSpendLimit = !!subagentSpendLimit;

  const isShowAgencyBalance = getIsShowAgencyBalance({
    isMasterMoneySource,
    isSubagentSpendLimit,
    isAgencyBalanceVisible,
  });

  const balanceString = getBalanceString({ balance, auctionPoints, isShowAgencyBalance });

  const handleDepositLinkClick = React.useCallback(() => {
    if (canPayByCard) {
      trackNaturalDepositLinkClick({ analyticsOfferStatus, analyticsProduct });
    } else {
      trackLegalDepositLinkClick(analyticsOfferStatus);
    }

    dispatch(setRecommendedPackageCheckoutFillBalance(false));

    dispatch(topUpBalanceThunk(!!isMicrofrontend));
  }, [canPayByCard, analyticsOfferStatus, analyticsProduct, isMicrofrontend, dispatch]);

  const props = {
    showBalance: isMasterMoneySource ? isAgencyBalanceVisible : true,
    withMoneySource: isSubagent,
    withPay: canFillBalance,
    balanceString,
    handleDepositLinkClick,
  };

  return <Device desktop={<BalanceDesktop {...props} />} mobile={<BalanceMobile {...props} />} />;
};
